import React, { type FC, useEffect } from 'react'

import { useRecoilCallback } from 'recoil'

import { Flex, ToastContainer, Tooltip } from 'mailup-web-components'

import Page from 'Containers/Page'

import Header from 'Pages/GroupsList/components/Header'
import Info from 'Pages/GroupsList/components/Info'
import ModalDelete from 'Pages/GroupsList/components/ModalDelete'
import PanelEdit from 'Pages/GroupsList/components/PanelEdit'
import Results from 'Pages/GroupsList/components/Results'
import Search from 'Pages/GroupsList/components/Search'
import {
  initPageCallback,
  resetPageCallback,
} from 'Pages/GroupsList/recoil/callbacks/callbacks'
import ModalCopyToList from './components/ModalCopy'

const GroupsList: FC = () => {
  const initPage = useRecoilCallback(initPageCallback, [])
  const resetPage = useRecoilCallback(resetPageCallback, [])

  useEffect(() => {
    void initPage()

    return () => {
      void resetPage()
    }
  }, [initPage, resetPage])

  return (
    <>
      <Header />
      <Tooltip />
      <ToastContainer />

      <ModalDelete />
      <ModalCopyToList />

      <PanelEdit />

      <Page onReload={initPage}>
        <Flex flexDirection="column" gap="24px">
          <Search />
          <Info />
          <Results />
        </Flex>
      </Page>
    </>
  )
}

export default GroupsList
